var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMeetupinline = function SvgMeetupinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19.375,
    stroke: "#fff",
    strokeOpacity: 0.15,
    strokeWidth: 1.25
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M29.98 26.576c-.264-1.657-3.39-.38-3.583-2.196-.273-2.577 3.63-8.13 3.322-10.285-.277-1.94-1.609-2.347-2.768-2.367-1.126-.02-1.423.156-1.804.374-.22.124-.535.372-.973-.037-.291-.272-.483-.462-.792-.703a1.66 1.66 0 0 0-.825-.339c-.419-.06-.96 0-1.306.145-.345.145-.615.4-.9.641-.282.242-1 1.032-1.67.74-.291-.126-1.275-.609-1.985-.91-1.37-.582-3.348.361-4.06 1.604-1.058 1.846-3.149 9.107-3.466 10.064-.71 2.15.9 3.903 3.071 3.802.918-.043 1.529-.372 2.109-1.407.335-.598 3.483-8.67 3.717-9.057.17-.28.736-.651 1.217-.41.48.242.576.746.505 1.222-.115.768-2.335 5.692-2.42 6.25-.145.946.313 1.473 1.315 1.525.686.036 1.37-.207 1.914-1.212.304-.562 3.805-7.445 4.115-7.905.34-.505.614-.67.96-.653.27.014.7.081.593.873-.106.776-2.921 5.827-3.216 7.064-.396 1.653.53 3.327 2.052 4.06.971.468 5.221 1.268 4.878-.883"
  })));
};
export default SvgMeetupinline;